import Axios from 'axios';

export const getAddressByPostalCode = async (postalCode: string) => {
  const response = await Axios.get(
    `https://viacep.com.br/ws/${postalCode}/json/`,
  );

  return response.data;
};
